export default {
	"vehicleTrack": {
		"DateTime": "วันและเวลา"
	},
	"zdTrack": {
		"reanalysis": "วิเคราะห์ใหม่",
		"send": "ส่ง",
		"sendTo": "ส่งแล้ว",
		"receive": "รับ"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/components/zdTrack/zdTrack.js